import axios from 'api';
import { PHOENIXURL } from 'utils/Constants';
import { checkEnv } from 'utils/config';

const TOKEN = 'Bearer 1nj6STK4yyEdYm1tcI9eJX0HVyYr';

// Below object exposes all Phoenix API's
export const PhoenixServices = {
	getClients: async token => {
		const path = `${PHOENIXURL[checkEnv()]}clients`;
		const Headerdata = { Authorization: `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getAccounts: async (sponsorCode, token) => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}accounts?sponsor-code=${sponsorCode}`;
		const Headerdata = { Authorization: `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getHierarchies: async (sponsorCode, token) => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}account-groups?sponsor-code=${sponsorCode}`;
		const Headerdata = { Authorization: `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getBenchmarks: async (accountBid, token) => {
		const path = `${
			PHOENIXURL[checkEnv()]
		}benchmarks?account-bid=${accountBid}`;
		const Headerdata = { Authorization: `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getClientDimensions: async token => {
		const path = `${PHOENIXURL[checkEnv()]}client-dimensions`;
		const Headerdata = { Authorization: `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'GET',
			url: path,
			headers: { ...Headerdata },
		});
	},
	getMetrics : async (payload, token) => {
		const path = `${PHOENIXURL[checkEnv()]}metrics`;
		const Headerdata = { Authorization:  `Bearer ${token}`, type: 'phx' };

		return axios.request({
			method: 'POST',
			url: path,
			headers: { ...Headerdata },
			data: payload,
		});
	},
};
